import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса структуры базы 1С (срез ONEC-STRUCT): организация → подразделение →
 * склад. Литерал `/api/` законен только здесь.
 */
const base = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}`

export const ONEC_STRUCTURE_URLS = {
  structure: (resourceId: string) => `${base(resourceId)}/structure`,
  refresh: (resourceId: string) => `${base(resourceId)}/structure/refresh`,
} as const
